import { render, staticRenderFns } from "./footerLayout.vue?vue&type=template&id=5a57cd61&scoped=true&"
import script from "./footerLayout.vue?vue&type=script&lang=js&"
export * from "./footerLayout.vue?vue&type=script&lang=js&"
import style0 from "./footerLayout.vue?vue&type=style&index=0&id=5a57cd61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a57cd61",
  null
  
)

export default component.exports